<template>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg h-auto flex flex-col items-center justify-center w-full relative"
  >
    <div class="w-full max-h-[80vh] overflow-hidden flex flex-col">
      <div
        class="flex justify-between items-center p-6 border-b dark:border-gray-700"
      >
        <h3 class="text-xl font-bold dark:text-gray-200">
          Transaction History
        </h3>
        <button
          @click="$emit('close')"
          class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="overflow-y-auto flex-1 p-6">
        <div
          v-if="loading"
          class="text-center py-10 text-gray-500 dark:text-gray-400"
        >
          <i class="fas fa-spinner fa-spin text-2xl mb-4"></i>
          <p>Loading transactions...</p>
        </div>
        <div
          v-else-if="transactions.length === 0"
          class="text-center py-10 text-gray-500 dark:text-gray-400"
        >
          <i class="fas fa-exchange-alt text-4xl mb-4"></i>
          <p>No transactions yet</p>
        </div>

        <div v-else class="space-y-4">
          <div
            v-for="txn in transactions"
            :key="txn.id || txn.reference || txn.created_at"
            class="flex items-center justify-between p-4 border rounded-lg dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition"
          >
            <div class="flex items-center gap-4">
              <div
                :class="`w-10 h-10 rounded-full flex items-center justify-center ${
                  txn.type === 'credit'
                    ? 'bg-green-100 text-green-600'
                    : 'bg-red-100 text-red-600'
                }`"
              >
                <i
                  :class="
                    txn.type === 'credit'
                      ? 'fas fa-arrow-down'
                      : 'fas fa-arrow-up'
                  "
                ></i>
              </div>
              <div>
                <p class="font-medium dark:text-gray-200">
                  {{
                    txn.description ||
                    (txn.type === "credit" ? "Wallet Funded" : "Wallet Debited")
                  }}
                </p>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                  {{ formatDate(txn.created_at || txn.date) }}
                </p>
                <span
                  class="inline-block mt-1 px-2 py-0.5 rounded text-xs font-semibold"
                  :class="{
                    'bg-yellow-100 text-yellow-800': txn.status === 'pending',
                    'bg-green-100 text-green-800': txn.status === 'completed',
                    'bg-red-100 text-red-800': txn.status === 'failed',
                  }"
                >
                  {{
                    txn.status === "completed"
                      ? "Paid"
                      : txn.status.charAt(0).toUpperCase() + txn.status.slice(1)
                  }}
                </span>
              </div>
            </div>
            <div
              :class="`font-semibold ${
                txn.type === 'credit' ? 'text-green-600' : 'text-red-600'
              }`"
            >
              {{ txn.type === "credit" ? "+" : "-" }}₦{{
                Number(txn.amount).toLocaleString()
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="p-4 border-t dark:border-gray-700 flex justify-end">
        <button
          @click="$emit('close')"
          class="bg-main-500 dark:bg-sub-600 hover:bg-main-600 dark:hover:bg-sub-700 text-white py-2 px-6 rounded-lg transition"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      transactions: [],
      loading: true,
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    async fetchTransactions() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch("fetchWalletTransactions");
        if (result.success) {
          this.transactions = result.transactions;
        } else {
          this.transactions = [];
        }
      } catch (e) {
        this.transactions = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchTransactions();
  },
  watch: {
    accountId(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchTransactions();
    },
  },
};
</script>
